import React, { useContext, useState, useEffect } from 'react'
import moment from 'moment'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import CustomDialog from '@/product/components/organisms/Dialog'
import AuctionContext from '@/product/context/auction/auctionContext'
import { useHistory } from 'react-router-dom'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import Uploader from '@/product/common/uploader'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { LinearProgress } from '@mui/material'
import Loaders from '@/product/components/molecules/Loaders'

import CommonContext from '@/product/context/common/commonContext'
import ProductContext from '@/product/context/product/productContext'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import CustomTable from '@/product/components/molecules/CustomTable'
import { currencyFormat } from '@/custom/common/components'
import { Button } from '@mui/material'

import BidDeposit from '../BidDeposit/BidDeposit'

const SingleAuctionList = (props) => {
    const toggleFullScreenPopup = props.function
    const data = props.data
    const history = useHistory()
    const [auctionData, setAuctionData] = useState([])
    const [singleAuctionData, setSingleAuctionData] = useState([])
    const [salexTaxPopu, setSalesTaxpopu] = useState(false)
    const auctionContext = useContext(AuctionContext)

    const invoiceContext = useContext(InvoiceContext)
    const {
        single_auction,
        auction_projects,
        getSingleAuction,
        in_person_statistics,
        auctionAction,
        inPersonDashboard,
        changeAuctionStatus,
        responseStatus: AuctionResponseStatus,
    } = auctionContext
    const {
        all_invoices,
        getAllInvoices,
        changeProductStatus,
        responseStatus: responseStatusInvoice,
    } = invoiceContext

    const [tableBody, settableBody] = useState([])
    const [changeStatus, setChangeStatus] = useState(false)
    const ref = React.createRef()

    let initialValues = {
        // page: 1,
        // limit: 20,
        order: '',
        orderby: '',
        filters: {
            action: {
                value: null,
                type: 'in',
                field: 'b.paid',
            },
            actionlot: {
                value: data?.id ? data.id : null,
                type: 'in',
                field: 'ac.id',
            },
        },
    }

    useEffect(() => {
        if (data?.id) {
            getSingleAuction({
                id: data.id,
            })
            inPersonDashboard({
                auction_id: [data.id],
            })
            getAllInvoices(initialValues)
        }
    }, [data])

    useEffect(() => {
        if (single_auction.record) {
            setAuctionData(single_auction?.record)
        }
        if (in_person_statistics?.statisticCount) {
            setSingleAuctionData(in_person_statistics.statisticCount)
        }
    }, [single_auction, in_person_statistics])
    useEffect(() => {
        if (all_invoices?.records?.length > 0)
            settableBody(all_invoices.records)
    }, [all_invoices])

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const salesTaxHandleChange = () => {
        setSalesTaxpopu(!salexTaxPopu)
        settableBody([])
    }

    const closeAuctionSubmit = () => {
        if (data?.id)
            changeAuctionStatus({
                action: 'removed',
                action_id: [data.id],
                mainUpdate: false,
            })
    }

    const totalAmount = tableBody?.reduce(
        (calculate, currency) => calculate + currency.total_amount,
        0
    )
    const totalTaxAmount = tableBody?.reduce(
        (calculate, currency) => calculate + currency.total_tax,
        0
    )

    return (
        <>
            <FullScreenPopup
                modaltitle={'Mainfest Upload-Dashboard'}
                open={data.status === 'auctionListing' ? data?.popup : false}
                handleClose={() => toggleFullScreenPopup(false)}
            >
                <div className="addUserModal singleAucAddUserModal">
                    <div className="singleAucListing">
                        <div>
                            <span>Start Time :</span>
                            <div className="itemTimerData">
                                <span>
                                    {dateTimeFormatFunction(
                                        auctionData.date_added
                                    )}
                                </span>
                            </div>
                        </div>
                        <div>
                            <span>End Time :</span>
                            <div className="itemTimerData">
                                <span>
                                    {dateTimeFormatFunction(
                                        auctionData.date_added
                                    )}
                                </span>
                            </div>
                        </div>
                        <div>
                            <span>Last Item Closing Time :</span>
                            <div className="itemTimerData">
                                <span>
                                    {dateTimeFormatFunction(
                                        singleAuctionData.last_item_close_date
                                    )}
                                </span>
                            </div>
                        </div>
                        <div>
                            <span>No of Items sold :</span>
                            <span>
                                {singleAuctionData.count_sold
                                    ? singleAuctionData.count_sold
                                    : 0}
                            </span>
                        </div>
                        <div>
                            <span>No of Items unsold :</span>
                            <span>
                                {singleAuctionData.count_unsold
                                    ? singleAuctionData.count_unsold
                                    : 0}
                            </span>
                        </div>
                        <div>
                            <span>No of Items open :</span>
                            <span>
                                {singleAuctionData?.count_open
                                    ? singleAuctionData?.count_open
                                    : 0}
                            </span>
                        </div>
                        <div>
                            <span>No of Items :</span>
                            <span>
                                {singleAuctionData.count_lot_all
                                    ? singleAuctionData.count_lot_all
                                    : 0}
                            </span>
                        </div>

                        <div>
                            <span>Sum per Total amount :</span>
                            <span>
                                {singleAuctionData.sum_per_total
                                    ? singleAuctionData.sum_per_total
                                    : 0}
                            </span>
                        </div>
                        <div>
                            <span>Bid vs No Bids :</span>
                            <span>
                                {singleAuctionData.bidscount
                                    ? singleAuctionData.bidscount
                                    : 0}
                            </span>
                        </div>
                        <div>
                            <span>total High Bids:</span>
                            <span>
                                {singleAuctionData.top_bid
                                    ? singleAuctionData.top_bid
                                    : 0}
                            </span>
                        </div>
                        <div>
                            <span>Max potential:</span>
                            <span>
                                {singleAuctionData.top_proxybid
                                    ? singleAuctionData.top_proxybid
                                    : 0}
                            </span>
                        </div>
                        <div>
                            <span>Number of Bidders:</span>
                            <span>
                                {singleAuctionData.bidders_count
                                    ? singleAuctionData.bidders_count
                                    : 0}
                            </span>
                        </div>
                        <div>
                            <span>Winning Bidders:</span>
                            <span>
                                {singleAuctionData.winners_count
                                    ? singleAuctionData.winners_count
                                    : 0}
                            </span>
                        </div>
                    </div>
                    <div className="singleLstAuLnks">
                        <div>
                            <span>Auction Auctions</span>
                            <ul>
                                <li>
                                    {' '}
                                    <a
                                        href={`${process.env.REACT_APP_FRONTEND_URL}/liveAuction/${data?.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Preview Auction
                                    </a>
                                </li>
                                <li
                                // onClick={() => {
                                //     handleRedirectInternal(
                                //         history,
                                //         `auction/edit/${data?.id}`
                                //     )
                                // }}
                                >
                                    <a
                                        href={`${process.env.REACT_APP_ADMIN_URL}/auction/edit/${data?.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Edit Auction
                                    </a>
                                </li>
                                <li
                                    onClick={() => {
                                        handleRedirectInternal(
                                            history,
                                            `auction/edit/${data?.id}`
                                        )
                                    }}
                                >
                                    <a
                                        href={`${process.env.REACT_APP_ADMIN_URL}/auction/edit/${data?.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Copy Auction
                                    </a>
                                </li>
                                <li
                                // onClick={() => {
                                //     handleRedirectInternal(
                                //         history,
                                //         `report/bidder/${data?.id}`
                                //     )
                                // }}
                                >
                                    <a
                                        href={`${process.env.REACT_APP_ADMIN_URL}/report/bidder/${data?.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Bidder List
                                    </a>
                                </li>
                                <li
                                // onClick={() => {
                                //     handleRedirectInternal(
                                //         history,
                                //         `report/auction/${data?.id}`
                                //     )
                                // }}
                                >
                                    <a
                                        href={`${process.env.REACT_APP_ADMIN_URL}/report/auction/${data?.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Auction Report
                                    </a>
                                </li>
                                <li
                                    onClick={() => {
                                        setChangeStatus(true)
                                    }}
                                >
                                    Delete Auction
                                </li>
                                {/* <li>Download Catalog</li> */}
                            </ul>
                        </div>
                        <div>
                            <span>Item Auctions</span>
                            <ul>
                                <li
                                // onClick={() => {
                                //     handleRedirectInternal(
                                //         history,
                                //         `listing/all/${data?.id}`
                                //     )
                                // }}
                                >
                                    <a
                                        href={`${process.env.REACT_APP_ADMIN_URL}/listing/all/${data?.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Item List
                                    </a>
                                </li>
                                <li
                                // onClick={() => {
                                //     handleRedirectInternal(
                                //         history,
                                //         `listing/new/0`
                                //     )
                                // }}
                                >
                                    <a
                                        href={`${process.env.REACT_APP_ADMIN_URL}/listing/new/0}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Add Items
                                    </a>
                                </li>
                                <li
                                // onClick={() => {
                                //     handleRedirectInternal(
                                //         history,
                                //         `listing/new/0`
                                //     )
                                // }}
                                >
                                    <a
                                        href={`${process.env.REACT_APP_ADMIN_URL}/listing/new/0}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Add One Item
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <span>Invoice Auctions</span>
                            <ul>
                                <li
                                // onClick={() => {
                                //     handleRedirectInternal(
                                //         history,
                                //         `invoice/all/${data?.id}`
                                //     )
                                // }}
                                >
                                    <a
                                        href={`${process.env.REACT_APP_ADMIN_URL}/invoice/all/${data?.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Invoices
                                    </a>
                                </li>
                                <li
                                // onClick={() => {
                                //     handleRedirectInternal(
                                //         history,
                                //         `invoice/all/${data?.id}`
                                //     )
                                // }}
                                >
                                    <a
                                        href={`${process.env.REACT_APP_ADMIN_URL}/invoice/all/${data?.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Print All Invoices
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <span>Reports</span>
                            <ul>
                                <li
                                    onClick={() => {
                                        setSalesTaxpopu(true)
                                    }}
                                >
                                    Sales Tax
                                </li>
                                <li
                                // onClick={() => {
                                //     handleRedirectInternal(
                                //         history,
                                //         `invoice/all/${data?.id}`
                                //     )
                                // }}
                                >
                                    <a
                                        href={`${process.env.REACT_APP_ADMIN_URL}/invoice/all/${data?.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Buyer Invoice Summary
                                    </a>
                                </li>
                                <li
                                // onClick={() => {
                                //     handleRedirectInternal(
                                //         history,
                                //         `report/invoice/${data?.id}`
                                //     )
                                // }}
                                >
                                    {' '}
                                    <a
                                        href={`${process.env.REACT_APP_ADMIN_URL}/report/invoice/${data?.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Auction Results
                                    </a>
                                </li>
                                <li>
                                    {' '}
                                    <a
                                        href={`${process.env.REACT_APP_ADMIN_URL}/report/bidder/${data?.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Resale Bidders Report
                                    </a>{' '}
                                </li>
                                <li>
                                    <a
                                        href={`${process.env.REACT_APP_ADMIN_URL}/report/unsold
                                        /${data?.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {' '}
                                        Unsold Lots
                                    </a>
                                </li>
                                {/* <li>Pickup Schedule Report</li> */}
                                <li
                                // onClick={() => {
                                //     handleRedirectInternal(
                                //         history,
                                //         `report/invoice/${data?.id}`
                                //     )
                                // }}
                                >
                                    {' '}
                                    <a
                                        href={`${process.env.REACT_APP_ADMIN_URL}/report/invoice/${data?.id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Invoices Report
                                    </a>{' '}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </FullScreenPopup>

            <CustomDialog
                title={'Print Sales Tax'}
                open={salexTaxPopu}
                function={salesTaxHandleChange}
            >
                <div className="d-flex justify-content-center align-items-center mb-2 noPrint">
                    sales Tax Report for : Bid increment
                </div>
                <div
                    className={`
                        invoiceViewPrint
                    `}
                    ref={ref}
                    style={{ height: '100%', width: '100%' }}
                >
                    <div className="d-flex justify-content-end align-items-center mb-2 noPrint">
                        <Button
                            id="invoice_print"
                            onClick={() => window.print()}
                        >
                            <span className="material-icons">print</span>
                            {'Print'}
                        </Button>
                    </div>
                    <div className="addUserModal singleAucAddUserModal">
                        <table className="table ">
                            <thead>
                                <tr>
                                    <th scope="col">Invoice</th>
                                    <th scope="col">Buyer</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Tax percentage</th>
                                    <th scope="col">Taxable Amount</th>
                                    <th scope="col">Tax</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableBody.length > 0 ? (
                                    <>
                                        {tableBody.map((data, index) => (
                                            <>
                                                <tr>
                                                    <td>{data?.invoice_id}</td>
                                                    <td>{data.users_id}</td>
                                                    <td>{data.qty}</td>
                                                    <td>{data.tax_percent}%</td>
                                                    <td>
                                                        {currencyFormat(
                                                            data.total_amount
                                                        )}
                                                    </td>
                                                    <td>
                                                        {currencyFormat(
                                                            data.total_tax
                                                        )}
                                                    </td>
                                                </tr>
                                            </>
                                        ))}
                                        <tr>
                                            <td></td>
                                            <td> </td>
                                            <td>Total</td>
                                            <td>
                                                {currencyFormat(totalAmount)}
                                            </td>
                                            <td>
                                                {currencyFormat(totalTaxAmount)}
                                            </td>
                                        </tr>
                                    </>
                                ) : (
                                    <>
                                        <tr>
                                            <td
                                                className="text-center"
                                                colSpan={3}
                                            >
                                                No Bids Found!
                                            </td>
                                        </tr>
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </CustomDialog>
            <CustomDialog
                title={'Change auction status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to delete this auction</h5>

                <div className="actionWrapper">
                    <Button
                        id="auction_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>

                    <PrimaryButton
                        id="auction_table_submit"
                        type="submit"
                        label="Confirm"
                        onClick={() => {
                            closeAuctionSubmit()
                        }}
                    />
                </div>
            </CustomDialog>
        </>
    )
}

export default SingleAuctionList
